import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { countries, languagesAll } from "countries-list";
import range from "lodash/range";
import customLanguagesList from "./customLanguages.json";
var languageRE = /^([a-z]{2,3})([-_]|$)/,
  regionRE = /[-_]([A-Z]{2})([-_]|$)/;
export var getLanguageSubtag = function (locale) {
  var caseInsensitiveLocale = locale.toLowerCase(),
    r = languageRE.exec(caseInsensitiveLocale);
  return r ? r[1] : void 0;
};
export var getCountryCodeFromLocale = function (locale) {
  return function (locale) {
    var caseInsensitiveLocale = locale.toUpperCase(),
      r = regionRE.exec(caseInsensitiveLocale);
    return r ? r[1] : void 0;
  }(locale);
};
export var getLanguageFromLocale = function (locale) {
  return getLanguageSubtag(locale);
};
export var getBrowserLanguage = function () {
  return window.navigator.userLanguage || window.navigator.language;
};
export var normalizeToUnderscoreLocale = function (locale) {
  return locale.replace("-", "_");
};
export var isIntlShape = function (content) {
  return content && void 0 !== content.id && void 0 !== content.defaultMessage;
};
export var getFormattedMonthsForLocale = function (locale) {
  var _context;
  return _mapInstanceProperty(_context = range(12)).call(_context, function (month) {
    return locale.localize.month(month);
  });
};
var languagesListWithPseudoLocales = _objectSpread(_objectSpread({}, customLanguagesList), languagesAll);
export var getNativeLocaleLanguage = function (locale) {
  var _context2,
    languageCode = getLanguageFromLocale(locale),
    countryCode = getCountryCodeFromLocale(locale),
    languageMapping = void 0 !== languageCode ? languagesAll[languageCode] : void 0,
    countryMapping = void 0 !== countryCode ? countries[countryCode] : void 0;
  return languageMapping && countryMapping ? _concatInstanceProperty(_context2 = "".concat(languageMapping.native, " (")).call(_context2, countryMapping.native, ")") : void 0 !== languageCode && languagesListWithPseudoLocales[locale] ? languagesListWithPseudoLocales[locale].native : void 0;
};